import Router from './router';
import history from './history';
import Routes from './routes';

export { history, Routes };

export default Router;
